import React from "react"
import { useStaticQuery, graphql } from "gatsby";

import Link from "./Link"
import Container from './container'

import VerdensKulesteDagLogo from '../../static/images/vkd.inline.svg';
import SparebankstiftelsenLogo from '../../static/images/sparebankstiftelsen.inline.svg'
import SentralenLogo from '../../static/images/sentralen-small.inline.svg'

const Header = ({ className, navigation = true, children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site: sanitySettings {
        maintenance
        menu {
          text
          link {
            external
            internal {
              ... on SanityActivity {
                slug {
                  current
                }
              }
              ... on SanityPage {
                slug {
                  current
                }
              }
            }
          }
        }
      }
    }
  `)

  const {
    maintenance,
    menu
  } = data?.site;

  return (
    <Container className={className}>
      <nav className={`${navigation ? 'flex' : 'hidden'} flex-wrap items-center justify-between pt-[30px] md:pt-[60px]`}>
        <div className={`justify-center flex items-center md:flex-shrink-0 md:mr-6`}>
          <Link to="/" className={`max-w-[210px] lg:max-w-full shadow-none`}>
            <VerdensKulesteDagLogo className={`w-full`} />
          </Link>
        </div>
        { maintenance === false && (
          <div className={`pt-[32px] md:pt-0 w-full md:w-auto flex justify-between md:grid md:grid-flow-col md:gap-x-[25px] lg:gap-x-[50px] text-sm order-3 md:order-2`}>
            {menu && menu.map((item, index) => {
              const { text, link } = item;

              const url = link.external
                ? link.external
                : `/${link.internal.slug.current}/`;

              return (
                <Link
                  key={index}
                  to={url}
                  className={`py-[5px] text-base md:text-base-md`}
                  activeClassName={`u-underline`}
                  partiallyActive={true}
                >
                  { text }
                </Link>
              )
            })}
          </div>
        )}
        <div className={`order-2 md:order-3 max-w-[60px] md:max-w-[80px]`}>
          <Link to={`https://sparebankstiftelsen.no`} className={`md:flex md:mb-[16px] u-underline-none`} target={`_blank`}>
            <SparebankstiftelsenLogo className={`w-full`} />
          </Link>
          <Link to={`https://www.sentralen.no`} className={`flex u-underline-none`} target={`_blank`}>
            <SentralenLogo className={`w-full`} />
          </Link>
        </div>
      </nav>
      { children }
    </Container>
  )
}

export default Header
